module.exports = __webpack_public_path__ + "media/theme/step--3--close-0ddfa0c0.png";